import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import useUserContext from '../../../common/hooks/useUserContext';
import config from '../../../config/Config';
import UserSecurityQuestions from '../../userSecurityQuestion/components/UserSecurityQuestions';
import { setIframe } from '../services/coreIFrameHelper';

const IFrame = styled.iframe`
  position: absolute;
  height: 100%;
  width: 100%;
`;

const CorePillarFrame = () => {
  const { user } = useUserContext();
  const [frameSource, setFrameSource] = useState('');
  const coreframe = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const container = document.getElementById('CoreIFrame');
    if (
      container &&
      container.getAttribute('src') === '' &&
      location.pathname.toLowerCase().indexOf('/c/') > -1
    ) {
      setIframe(`${location.pathname.replace(/\/c/i, 'core')}${location.search}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const coreUrl = `${config.domain}core/?rc=1`;
    const homeUrl = user.homePageUrl ? user.homePageUrl.split('?')[0] : '';
    const currentUrl = window.location.pathname.toLowerCase().replace('/rcore/c', '/c');
    if (
      (currentUrl === '/rcore' ||
        currentUrl.indexOf('/c/') === -1 ||
        currentUrl === homeUrl.toLowerCase()) &&
      coreframe.current !== null &&
      coreframe.current.getAttribute('src') === ''
    ) {
      setFrameSource(coreUrl);
    }
  }, [user.homePageUrl]);

  return (
    <>
      <IFrame
        ref={coreframe}
        src={frameSource}
        title="Core page frame"
        style={{
          visibility: 'hidden',
          opacity: '1',
          zIndex: '-2'
        }}
        id="CoreIFrame"
        frameBorder="0"
        allowFullScreen
      />
      {user.UserJustAnsweredSecurityQuestion === true && <UserSecurityQuestions />}
    </>
  );
};

export default CorePillarFrame;
